var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "w-100" }, [
    _c("tr", [
      _c("td", [
        _c("div", { staticClass: "form-check mr-2" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.dutyCreate.duty.cbmAnonymousEnabled,
                expression: "dutyCreate.duty.cbmAnonymousEnabled"
              }
            ],
            staticClass: "form-check-input",
            attrs: {
              type: "checkbox",
              id: "cbmInsertIntoWorkflowEnabled" + _vm._uid
            },
            domProps: {
              checked: Array.isArray(_vm.dutyCreate.duty.cbmAnonymousEnabled)
                ? _vm._i(_vm.dutyCreate.duty.cbmAnonymousEnabled, null) > -1
                : _vm.dutyCreate.duty.cbmAnonymousEnabled
            },
            on: {
              change: function($event) {
                var $$a = _vm.dutyCreate.duty.cbmAnonymousEnabled,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(
                        _vm.dutyCreate.duty,
                        "cbmAnonymousEnabled",
                        $$a.concat([$$v])
                      )
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.dutyCreate.duty,
                        "cbmAnonymousEnabled",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.dutyCreate.duty, "cbmAnonymousEnabled", $$c)
                }
              }
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: "cbmInsertIntoWorkflowEnabled" + _vm._uid }
            },
            [_vm._v(_vm._s(_vm.$t("duty.cbm.anonymousId")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("td", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dutyCreate.duty.cbmAnonymousEnabled,
                expression: "dutyCreate.duty.cbmAnonymousEnabled"
              }
            ],
            staticClass: "input-group"
          },
          [
            _c("input", {
              staticClass: "form-control",
              attrs: { disabled: true },
              domProps: { value: _vm.cbmAnonymousIdUrl }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: { click: _vm.copyLink }
                },
                [_c("i", { staticClass: "fa fa-copy" })]
              )
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("tr", [
      _c("td", [
        _c("div", { staticClass: "form-check mr-2" }, [
          _c(
            "label",
            {
              staticClass: "form-check-label",
              attrs: { for: "cbmAuthedId" + _vm._uid }
            },
            [_vm._v(_vm._s(_vm.$t("duty.cbm.authedId")))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("td", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.dutyCreate.duty.cbmAuthedId,
              expression: "dutyCreate.duty.cbmAuthedId"
            }
          ],
          staticClass: "form-control",
          domProps: { value: _vm.dutyCreate.duty.cbmAuthedId },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.dutyCreate.duty, "cbmAuthedId", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _vm.anyCbmEnabled && _vm.canWorkFlow
      ? _c("tr", [
          _c("td", [
            _c("div", { staticClass: "form-check mr-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dutyCreate.duty.cbmInsertIntoWorkflowEnabled,
                    expression: "dutyCreate.duty.cbmInsertIntoWorkflowEnabled"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "checkbox",
                  id: "cbmInsertIntoWorkflowEnabled" + _vm._uid
                },
                domProps: {
                  checked: Array.isArray(
                    _vm.dutyCreate.duty.cbmInsertIntoWorkflowEnabled
                  )
                    ? _vm._i(
                        _vm.dutyCreate.duty.cbmInsertIntoWorkflowEnabled,
                        null
                      ) > -1
                    : _vm.dutyCreate.duty.cbmInsertIntoWorkflowEnabled
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.dutyCreate.duty.cbmInsertIntoWorkflowEnabled,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.dutyCreate.duty,
                            "cbmInsertIntoWorkflowEnabled",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.dutyCreate.duty,
                            "cbmInsertIntoWorkflowEnabled",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(
                        _vm.dutyCreate.duty,
                        "cbmInsertIntoWorkflowEnabled",
                        $$c
                      )
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "cbmInsertIntoWorkflowEnabled" + _vm._uid }
                },
                [_vm._v(_vm._s(_vm.$t("duty.cbm.insertIntoWorkflow")))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dutyCreate.duty.cbmInsertIntoWorkflowFlow,
                  expression: "dutyCreate.duty.cbmInsertIntoWorkflowFlow"
                }
              ],
              staticClass: "form-control",
              domProps: {
                value: _vm.dutyCreate.duty.cbmInsertIntoWorkflowFlow
              },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.dutyCreate.duty,
                    "cbmInsertIntoWorkflowFlow",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.anyCbmEnabled
      ? _c("tr", [
          _c("td", [
            _c("div", { staticClass: "form-check mb-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dutyCreate.duty.cbmAutoCloseActivity,
                    expression: "dutyCreate.duty.cbmAutoCloseActivity"
                  }
                ],
                staticClass: "form-check-input",
                attrs: {
                  type: "checkbox",
                  id: "cbmAutoCloseActivity" + _vm._uid
                },
                domProps: {
                  checked: Array.isArray(
                    _vm.dutyCreate.duty.cbmAutoCloseActivity
                  )
                    ? _vm._i(_vm.dutyCreate.duty.cbmAutoCloseActivity, null) >
                      -1
                    : _vm.dutyCreate.duty.cbmAutoCloseActivity
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.dutyCreate.duty.cbmAutoCloseActivity,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.dutyCreate.duty,
                            "cbmAutoCloseActivity",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.dutyCreate.duty,
                            "cbmAutoCloseActivity",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.dutyCreate.duty, "cbmAutoCloseActivity", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "form-check-label",
                  attrs: { for: "cbmAutoCloseActivity" + _vm._uid }
                },
                [_vm._v(_vm._s(_vm.$t("duty.cbm.autoCloseActivity")))]
              )
            ])
          ]),
          _vm._v(" "),
          _c("td")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.anyCbmEnabled
      ? _c("tr", [
          _c("td", [
            _c("div", { staticClass: "form-check mr-2" }, [
              _c("label", { staticClass: "form-check-label" }, [
                _vm._v(" " + _vm._s(_vm.$t("duty.titleRegex")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dutyCreate.duty.titleRegex,
                  expression: "dutyCreate.duty.titleRegex"
                }
              ],
              staticClass: "form-control",
              domProps: { value: _vm.dutyCreate.duty.titleRegex },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.dutyCreate.duty,
                    "titleRegex",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.anyCbmEnabled
      ? _c("tr", [
          _c("td", [
            _c("div", { staticClass: "form-check mr-2" }, [
              _c("label", { staticClass: "form-check-label" }, [
                _vm._v(" " + _vm._s(_vm.$t("duty.ignoreRegex")))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dutyCreate.duty.ignoreRegex,
                  expression: "dutyCreate.duty.ignoreRegex"
                }
              ],
              staticClass: "form-control",
              domProps: { value: _vm.dutyCreate.duty.ignoreRegex },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.dutyCreate.duty,
                    "ignoreRegex",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }